import { ReadDataService } from '../../../services/base/ReadDataService';
import { withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';
import { ProjectDocFolderAttachment } from '../models/ProjectDocFolderAttachment';
import { ProjectDocFolderAttachmentQuery } from '../models/ProjectDocFolderAttachmentQuery';

export class PDFAttachmentsService extends ReadDataService<
    ProjectDocFolderAttachment,
    ProjectDocFolderAttachmentQuery,
    number
> {
    protected prefixUrl: string = `PDFAttachments`;

    uploadFiles(
        folderId: number,
        files: File[],
        metadata?: { cypher?: string; documentOrganization?: string },
        typeId?: number,
    ) {
        const data = new FormData();
        const name = 'uploadFiles';
        for (const file of files) {
            data.append(name, file, file.name);
        }
        if (metadata?.cypher) data.append('cypher', metadata.cypher);
        if (metadata?.documentOrganization) data.append('documentOrganization', metadata.documentOrganization);

        const url =
            typeId != null
                ? `${this.prefixUrl}/UploadFiles?folderId=${folderId}&typeId=${typeId}`
                : `${this.prefixUrl}/UploadFiles?folderId=${folderId}`;

        return this.api.post(url, data, withUploadRejectionDetection({
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }));
    }

    delete(data: ProjectDocFolderAttachment[]) {
        return this.api.post(`${this.prefixUrl}/Delete`, data, { headers: { 'content-type': 'application/json' } });
    }
}
